import React, { useState, useEffect } from "react";
import {
  Container,
  Paper,
  Button,
  Box,
  Typography,
  IconButton,
  useMediaQuery,
  Grid,
  Skeleton,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import ChevronLeftOutlined from "@mui/icons-material/ChevronLeftOutlined";
import Menu from "@mui/icons-material/Menu";
import { useNavigate, useLocation } from "react-router-dom";
import Navigation from "../../../components/Navigation";
import HazardForm from "../../../components/HealthAndSafety/HazardForm";
import AccidentForm from "../../../components/HealthAndSafety/AccidentForm";
import IncidentForm from "../../../components/HealthAndSafety/IncidentForm";
import SnackbarAlert from "../../../components/SnackbarAlert";
import ConfirmModal from "../../../components/ConfirmModal";
import MenuComponent from "../../../components/MenuComponent";
import routes from "../../../routes";
import {
  hazardRequestFields,
  incidentRequestFields,
  accidentRequestFields,
  getAddress,
  convertToBodyParts,
} from "../../../services/helper";
import nucleusxp from "nucleusxp";
const CreateReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [confirmModal, setConfirmModal] = useState(false);
  const [individualsList, setIndividualsList] = useState([]);
  const [involvesPerson, setInvolvesPerson] = useState(false);
  const [involvesEquipment, setInvolvesEquipment] = useState(false);
  const [involvesMaterial, setInvolvesMaterial] = useState(false);
  const [fileNames, setFileNames] = useState([]);
  const [fromInsight, setFromInsight] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [highlightedField, setHighlightedField] = useState(null);
  const [isDraft, setIsDraft] = useState(false);
  const [nextActionModal, setNextActionModal] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });
  const [formData, setFormData] = useState({
    description: "",
    categoryType: "",
    hazard: "",
    otherType: "",
    sendLocation: "",
    enterLocation: "",
    reportedBy: "",
    dateOfObservation: "",
    individualsAffected: "",
    risk: "",
    priority: "",
    severity: "",
    actionRequired: "",
    status: "Pending",
    attachedFile: [],
    reportType: "",
    date: "",
    reportableAccident: "",
    otherReporter: "",
    firstLine: "",
    secondLine: "",
    province: "",
    postcode: "",
    additionalComments: "",
    reportedByIndex: 0,
    managerNotes: "",
  });
  useEffect(() => {
    if (state && state.reportType) {
      setFormData((prev) => ({ ...prev, type: state.reportType }));
    }
    if (state?.id) {
      const fetchReport = async () => {
        try {
          setLoading(true);
          const response = await nucleusxp.healthSafety.getReport(state.id);
          const report = response.item;
          const attachedFile = report?.files.map((file) => {
            return {
              url: file.url,
              name: file.caption,
            };
          });
          // ? await Promise.all(
          //     report.files.map((file) =>
          //       convertFileFromBackendResponse(file),
          //     ),
          //   )
          // : [];
          setFileNames(attachedFile);
          const geolocation =
            report.geolocation &&
            typeof report.geolocation.lat === "number" &&
            typeof report.geolocation.lng === "number"
              ? await getAddress(report.geolocation)
              : `${report?.location?.addressLine1 || ""}, ${report?.location?.state || ""}, ${report?.location?.postcode || ""}`;
          setFormData((prev) => ({
            ...prev,
            categoryType: report?.hazard ?? "",
            description: report?.description ?? "",
            otherType: report?.otherType ?? "",
            sendLocation: geolocation,
            location: report?.geolocation ?? "",
            reportedBy: report?.reportedBy ?? 0,
            dateOfObservation: report?.incidentAt ?? "",
            individuals: report?.individualsAffected ?? [],
            bodyPartsData:
              convertToBodyParts(report?.individualsAffected) ?? [],
            equipmentList: report?.equipmentAffected ?? [],
            materialList: report?.materialAffected ?? [],
            risk: report?.risk ?? "",
            priority: report?.priority ?? "",
            // actionRequired: report?.actionRequired ?? "",
            attachedFile: attachedFile,
            date: report?.updatedAt ?? "",
            otherReporter: report?.reportedOther ?? "",
            firstLine: report?.location?.addressLine1 ?? "",
            secondLine: report?.location?.addressLine2 ?? "",
            province: report?.location?.state ?? "",
            postcode: report?.location?.postcode ?? "",
            additionalComments: report?.comments ?? "",
            managerNotes: report?.managerNotes ?? "",
            type: report?.reportType,
            reportType: report?.reportType,
            status: report?.status,
          }));
          setLoading(false);
        } catch (e) {
          console.log("error: " + e);
          setLoading(false);
        }
      };
      fetchReport();
      setFromInsight(state.fromInsight);
      if (state.highlighted) setHighlightedField(state.highlighted);
    }
  }, [state]);

  const handleChange = (e) => {
    const { name } = e.target;
    let value;
    if (name === "attachedFile") {
      let file = e.target?.files[0];
      value = new File([file], file.name, { type: file.type });
      setFormData({
        ...formData,
        [name]: [...(formData[name] || []), value],
      });
    } else if (name === "removeFile") {
      value = e.target.value;
      setFormData((prev) => ({
        ...prev,
        attachedFile: prev.attachedFile.filter(
          (fileName) => fileName !== value,
        ),
      }));
    } else {
      value = e.target.value;
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleEdit = (field, value) => {
    if (field === "attachedFile") {
      value = value.name;
    }
    setHighlightedField(field);
    setFormData((prevData) => ({ ...prevData, [field]: value }));
  };
  const [drawerOpen, setDrawerOpen] = useState(false); // State to manage Drawer open/close

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen); // Toggle Drawer visibility
  };

  const handlePostReport = async (
    formData,
    reportType,
    additionalData = {},
  ) => {
    const baseReport = {
      description: formData.description,
      hazard: formData.categoryType,
      geolocation: formData.location ?? "",
      location: {
        addressLine1: formData.firstLine ?? "",
        addressLine2: formData.secondLine ?? "",
        state: formData.province ?? "",
        postcode: formData.postcode ?? "",
      },
      reportedBy: formData.reportedBy,
      reportedOther: formData.otherReporter ?? "",
      incidentAt: formData.dateOfObservation,
      comments: formData.additionalComments,
      reportType,
      ...additionalData, // Additional report-specific data
    };

    // Post the report
    const response = await nucleusxp.healthSafety.postReport(baseReport);

    // Post attached files if response contains an ID
    if (response?.id && formData.attachedFile?.length) {
      await nucleusxp.healthSafety.postReportFile(
        response.id,
        formData.attachedFile[0],
      );
    }
  };

  const handlePatchReport = async (
    stateId,
    formData,
    reportType,
    additionalData = {},
  ) => {
    const baseReport = {
      ...formData,
      description: formData.description,
      hazard: formData.categoryType,
      geolocation: formData.sendLocation ?? "",
      location: {
        addressLine1: formData.firstLine ?? "",
        addressLine2: formData.secondLine ?? "",
        state: formData.province ?? "",
        postcode: formData.postcode ?? "",
      },
      reportedBy: formData.reportedBy,
      reportedOther: formData.otherReporter ?? "",
      incidentAt: formData.dateOfObservation,
      comments: formData.additionalComments,
      reportType,
      ...additionalData, // Additional report-specific data
    };

    // Patch the report
    await nucleusxp.healthSafety.patchReport(stateId, baseReport);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const individualsList =
      formData.individualsList?.map((name) => ({
        employee: formData.reportedByIndex,
        name: name,
      })) || [];
    try {
      setSendLoading(true);
      if (!state?.id) {
        switch (formData.type) {
          case "hazard":
            await handlePostReport(formData, "hazard", {
              risk: formData.risk,
              priority: formData.priority,
              individualsAffected: individualsList,
              status: "Pending",
            });
            break;
          case "incident":
            await handlePostReport(formData, "incident", {
              otherType: formData.otherType ?? "",
              individualsAffected: individualsList,
              risk: formData.risk,
              priority: formData.priority,
              status: "Pending",
            });
            break;
          case "accident":
            const personList = formData.individualsList?.map((name, index) => {
              try {
                const matchedBodyPartsData = formData.bodyPartsData.find(
                  (bodyParts) => bodyParts.id === index,
                );
                const bodyParts = matchedBodyPartsData?.bodyParts || [];
                const bodyPartsAffected = Object.keys(bodyParts).filter(
                  (key) => bodyParts[key] === true,
                );
                return {
                  employee: formData.reportedByIndex,
                  name: name,
                  bodyPartsAffected: bodyPartsAffected,
                };
              } catch (e) {
                return {
                  employee: formData.reportedByIndex,
                  name: name,
                  bodyPartsAffected: [],
                };
              }
            });
            const equipmentList =
              formData.equipmentList?.map((equip) => ({
                barcode: equip.barcode || "",
                type: equip.type || "",
                name: equip.name || "",
                id: equip.id || "",
                color: equip.color || "",
                description: equip.description || "",
              })) || [];
            const materialList =
              formData.materialList?.map((material) => ({
                type: material.type || "",
                name: material.name || "",
                idSQ: material.idSQ || "",
              })) || [];
            await handlePostReport(formData, "accident", {
              individualsAffected: personList,
              equipmentAffected: equipmentList,
              materialAffected: materialList,
              attachedFile: formData.attachedFile ?? [],
              reportableAccident: formData.reportableAccident,
              status: "Pending",
            });
            break;
          default:
        }
      } else {
        switch (formData.type) {
          case "hazard":
            await handlePatchReport(state.id, formData, "hazard", {
              risk: formData.risk,
              priority: formData.priority,
              individualsAffected: individualsList,
            });
            break;
          case "incident":
            await handlePatchReport(state.id, formData, "incident", {
              otherType: formData.otherType ?? "",
              individualsAffected: individualsList,
              risk: formData.risk,
              priority: formData.priority,
            });
            break;
          case "accident":
            const personList = formData.individualsList?.map((name, index) => {
              try {
                const matchedBodyPartsData = formData.bodyPartsData.find(
                  (bodyParts) => bodyParts.id === index,
                );
                const bodyParts = matchedBodyPartsData?.bodyParts || [];
                const bodyPartsAffected = Object.keys(bodyParts).filter(
                  (key) => bodyParts[key] === true,
                );
                return {
                  employee: formData.reportedByIndex,
                  name: name,
                  bodyPartsAffected: bodyPartsAffected,
                };
              } catch (e) {
                return {
                  employee: formData.reportedByIndex,
                  name: name,
                  bodyPartsAffected: [],
                };
              }
            });
            const equipmentList =
              formData.equipmentList?.map((equip) => ({
                barcode: equip.barcode || "",
                type: equip.type || "",
                name: equip.name || "",
                id: equip.id || "",
                color: equip.color || "",
                description: equip.description || "",
              })) || [];
            const materialList =
              formData.materialList?.map((material) => ({
                type: material.type || "",
                name: material.name || "",
                idSQ: material.idSQ || "",
              })) || [];
            await handlePatchReport(state.id, formData, "accident", {
              individualsAffected: personList,
              equipmentAffected: equipmentList,
              materialAffected: materialList,
              attachedFile: formData.attachedFile ?? [],
              reportableAccident: formData.reportableAccident,
            });
            break;
          default:
        }
      }

      setSendLoading(false);
      if (state.id) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "The Request is updated!",
        });
      } else {
        setSnackbar({
          open: true,
          severity: "success",
          message: "A new Request is created!",
        });
      }

      setIndividualsList([]);
      setInvolvesPerson(false);
      setInvolvesEquipment(false);
      setInvolvesMaterial(false);
      setFileNames([]);

      setFormData({
        ...formData,
        hazardLocation: "",
        description: "",
        categoryType: "",
        otherType: "",
        sendLocation: "",
        enterLocation: "",
        reportedBy: "",
        dateOfObservation: "",
        individualsAffected: "",
        risk: "",
        priority: "",
        attachedFile: [],
        status: "Pending",
        actionRequired: "",
        incidentLocation: "",
        nextStep: "",
        firstLine: "",
        secondLine: "",
        province: "",
        postcode: "",
        additionalComments: "",
        managerNotes: "",
      });
    } catch (error) {
      console.log(error);
      setSendLoading(false);
      setSnackbar({
        open: true,
        severity: "false",
        message: "Please check connection with server!",
      });
    }
    setConfirmModal(false);
    setNextActionModal(true);
  };
  const handleDraft = async () => {
    try {
      setSendLoading(true);
      switch (formData.type) {
        case "hazard":
          await handlePostReport(formData, "hazard", {
            risk: formData.risk,
            priority: formData.priority,
            individualsAffected: individualsList,
            status: "Draft",
          });
          break;
        case "incident":
          await handlePostReport(formData, "incident", {
            otherType: formData.otherType ?? "",
            individualsAffected: individualsList,
            risk: formData.risk,
            priority: formData.priority,
            status: "Draft",
          });
          break;
        case "accident":
          const personList = formData.individualsList?.map((name, index) => {
            try {
              const matchedBodyPartsData = formData.bodyPartsData.find(
                (bodyParts) => bodyParts.id === index,
              );
              const bodyParts = matchedBodyPartsData?.bodyParts || [];
              const bodyPartsAffected = Object.keys(bodyParts).filter(
                (key) => bodyParts[key] === true,
              );
              return {
                employee: formData.reportedByIndex,
                name: name,
                bodyPartsAffected: bodyPartsAffected,
              };
            } catch (e) {
              return {
                employee: formData.reportedByIndex,
                name: name,
                bodyPartsAffected: [],
              };
            }
          });
          const equipmentList = formData.equipmentList.map((equip) => ({
            barcode: equip.barcode || "",
            type: equip.type || "",
            name: equip.name || "",
            id: equip.id || "",
            color: equip.color || "",
            description: equip.description || "",
          }));
          const materialList = formData.materialList.map((material) => ({
            type: material.type || "",
            name: material.name || "",
            idSQ: material.idSQ || "",
          }));
          await handlePostReport(formData, "accident", {
            individualsAffected: personList,
            equipmentAffected: equipmentList,
            materialAffected: materialList,
            attachedFile: formData.attachedFile ?? [],
            reportableAccident: formData.reportableAccident,
            status: "Draft",
          });
          break;
        default:
      }
      setSendLoading(false);
      setSnackbar({
        open: true,
        severity: "success",
        message: "A new Request is saved to drafts!",
      });
      handleClear();
    } catch (error) {
      setSendLoading(false);
      setSnackbar({
        open: true,
        severity: "error",
        message: "Please check connection with server!",
      });
    }
    setConfirmModal(false);
    setNextActionModal(true);
  };

  const handleCancel = () => {};

  const handleClear = () => {
    setIndividualsList([]);
    setInvolvesPerson(false);
    setInvolvesEquipment(false);
    setInvolvesMaterial(false);
    setFileNames([]);
    setFormData({
      ...formData,
      hazardLocation: "",
      description: "",
      categoryType: "",
      otherType: "",
      sendLocation: "",
      enterLocation: "",
      reportedBy: "",
      dateOfObservation: "",
      individualsAffected: "",
      individualsList: "",
      risk: "",
      priority: "",
      attachedFile: [],
      status: "Pending",
      actionRequired: "",
      incidentLocation: "",
      nextStep: "",
      firstLine: "",
      secondLine: "",
      province: "",
      postcode: "",
      additionalComments: "",
      managerNotes: "",
    });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  let headerText = "Create Report";
  let subheaderText = "";
  let FormComponent;

  switch (formData.type) {
    case "hazard":
      headerText = "Create Hazard Report";
      subheaderText = "Hazards to avoid";
      FormComponent = HazardForm;
      break;
    case "incident":
      headerText = "Create Incident Report";
      subheaderText = "No injury, no damage";
      FormComponent = IncidentForm;
      break;
    case "accident":
      headerText = "Create Accident Report";
      subheaderText = (
        <>
          Accident - <span>injury or damage</span>
        </>
      );
      FormComponent = AccidentForm;
      break;
    default:
      FormComponent = null;
      break;
  }

  const handleApprove = async (e) => {
    e.preventDefault();
    setConfirmModal(false);
    try {
      await nucleusxp.healthSafety.patchReport(state.id, {
        ...formData,
        status: "Approved",
      });
      setSnackbar({
        open: true,
        severity: "success",
        message: `A ${formData.type} Request is approved!`,
      });
    } catch (error) {
      setSnackbar({
        open: true,
        severity: "error",
        message: `Please check connection with server`,
      });
    }
  };
  const handleQuery = async (e) => {
    e.preventDefault();
    setConfirmModal(false);
    try {
      await nucleusxp.healthSafety.patchReport(state.id, {
        ...formData,
        status: "Queried",
      });
      setSnackbar({
        open: true,
        severity: "success",
        message: `A ${formData.type} Request is queried!`,
      });
    } catch (error) {
      setSnackbar({
        open: true,
        severity: "error",
        message: `Please check connection with server`,
      });
    }
  };
  const handleReject = async (e) => {
    e.preventDefault();
    setConfirmModal(false);
    try {
      await nucleusxp.healthSafety.patchReport(state.id, {
        ...formData,
        status: "Rejected",
      });
      setSnackbar({
        open: true,
        severity: "success",
        message: `A ${formData.type} Request is rejected!`,
      });
    } catch (error) {
      setSnackbar({
        open: true,
        severity: "error",
        message: `Please check connection with server`,
      });
    }
  };

  const isNonMobile = useMediaQuery("(min-width:600px)");
  return (
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#ecf0f7",
      }}
    >
      <Box
        sx={{
          height: "129px",
          backgroundColor: "#1C1468",
          color: "white",
          display: "flex",
          alignItems: "center",
          marginLeft: "-24px",
          marginRight: "-24px",
          zIndex: 3,
          justifyContent: "space-between",
          position: "fixed",
          width: isNonMobile ? "444px" : "calc(100vw + 10px)",
        }}
      >
        <IconButton
          edge="start"
          sx={{ marginLeft: "10px" }}
          color="inherit"
          onClick={() => navigate(routes.healthSafety.path)}
        >
          <ChevronLeftOutlined />
        </IconButton>

        <Typography sx={{ fontSize: "16px" }} variant="h5" fontWeight="bold">
          {headerText}
        </Typography>

        <IconButton
          edge="end"
          color="inherit"
          sx={{ marginRight: "15px" }}
          onClick={handleDrawerToggle}
        >
          <Menu />
        </IconButton>
      </Box>
      <MenuComponent
        open={drawerOpen} // Drawer visibility
        onClose={handleDrawerToggle} // Handler to close the drawer
      />

      <Paper
        sx={{ backgroundColor: "#fff", padding: 3, margin: "159px 0 90px" }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setConfirmModal(true);
          }}
        >
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{ marginBottom: "30px" }}
          >
            {subheaderText}
          </Typography>
          <Typography>Fill in Report Details</Typography>
          {!loading ? (
            FormComponent && (
              <FormComponent
                formData={formData}
                handleChange={handleChange}
                individualsList={individualsList}
                setIndividualsList={setIndividualsList}
                fileNames={fileNames}
                setFileNames={setFileNames}
                highlightedField={highlightedField}
                {...(FormComponent !== AccidentForm
                  ? {}
                  : {
                      involvesPerson: involvesPerson,
                      setInvolvesPerson: setInvolvesPerson,
                      involvesEquipment: involvesEquipment,
                      setInvolvesEquipment: setInvolvesEquipment,
                      involvesMaterial: involvesMaterial,
                      setInvolvesMaterial: setInvolvesMaterial,
                    })}
              />
            )
          ) : (
            <Skeleton variant="rectangular" width={350} height={60} />
          )}

          {fromInsight && (
            <Grid
              container
              spacing={2}
              sx={{ marginTop: "20px", justifyContent: "center" }}
            >
              {/* Approve and Reject buttons on the same row */}
              <Grid item>
                <Button
                  variant="contained"
                  color="success"
                  sx={{ marginRight: "10px" }} // Margin to the right for spacing
                  onClick={handleApprove}
                >
                  Approve
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ marginRight: "10px" }} // Margin to the right for spacing
                  onClick={handleQuery}
                >
                  Query
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleReject}
                >
                  Reject
                </Button>
              </Grid>
            </Grid>
          )}
          <Box>
            <Button
              type="submit"
              variant="contained"
              color="success"
              sx={{ marginTop: "20px" }}
            >
              Submit
            </Button>
            <Button
              variant="contained"
              color="primary"
              sx={{ marginTop: "20px", marginLeft: "10px", float: "right" }}
              onClick={() => {
                setConfirmModal(true);
                setIsDraft(true);
              }}
            >
              Save Draft
            </Button>
          </Box>
        </form>
      </Paper>

      <Navigation />
      <SnackbarAlert
        open={snackbar.open}
        onClose={handleClose}
        severity={snackbar.severity}
        message={snackbar.message}
      />
      <ConfirmModal
        open={confirmModal}
        onClose={(field, value) => {
          console.log(field, value);
          setConfirmModal(false);
          if (field && typeof field !== "object" && value !== "backdropClick") {
            handleEdit(field, value);
          } else {
            handleCancel();
          }
        }}
        title={
          formData.type === "hazard"
            ? "Confirm Hazard Request"
            : formData.type === "incident"
              ? "Confirm Incident Request"
              : "Confirm Accident Request"
        }
        fields={
          formData.type === "hazard"
            ? hazardRequestFields
            : formData.type === "incident"
              ? incidentRequestFields
              : accidentRequestFields
        }
        formData={formData}
        handleEdit={handleEdit}
        handleDraft={handleDraft}
        handleConfirm={handleSubmit}
        handleChange={handleChange}
        isDraft={isDraft}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={sendLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Dialog open={nextActionModal} onClose={() => setNextActionModal(false)}>
        <DialogTitle>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Next Steps
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Do you want to create a new request or return to the main menu?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              setNextActionModal(false);
              setConfirmModal(false); // Ensure the confirm modal is closed
              handleClear(); // Reset form for a new request
            }}
          >
            Create New Request
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setNextActionModal(false);
              navigate("/health-and-safety"); // Navigate to the main menu
            }}
          >
            Return to Main Menu
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default CreateReport;
